import jsPDFCashByDateTemplate, { OutputType } from "./CashByDateTemplate";
import currency from 'currency.js'

// Date Fns is used to format the dates we receive
// from our API call
import { parseISO, format, parse } from 'date-fns';
import logo from '../../../assets/img/logo.jpg'; // Tell webpack this JS file uses this image


// define a generatePDF function that accepts a cashs argument
const generateCashByDatePrintPDF = (mainData, configData, parameters) => {
    const myDate = format(new Date(), 'dd/MM/yyyy')
    const dateFrom = format(new Date(parameters.date_from ), 'dd/MM/yyyy')          
    const dateTo = format(new Date(parameters.date_to ), 'dd/MM/yyyy')  
    const dataFrom = parameters.data_from === "" ? "0" : parameters.data_from
    const dataTo = parameters.data_to === "" ? "999999999" : parameters.data_to
    const currFormat = { decimal: ',', symbol: '', separator: '.' }

    var totalEnt = 0;
    var totalSal = 0;
    console.log("fechas",parameters.date_from, parameters.date_to, dateFrom, dateTo )
    mainData.forEach(function (record) {
        totalEnt += record.income;
        totalSal += record.outcome;
    });


    var openingAmount = 0.00
    var closingAmount = 0.00

    totalEnt = currency(totalEnt, currFormat).format()
    totalSal = currency(totalSal, currFormat).format()

    var arrLines = Array.from(mainData, (item, index) => ([
        index + 1,
        format(new Date(item.date+ 'T23:59:59.999Z'), 'dd/MM/yyyy'),
        item.description,
        currency(item.amount_open, currFormat).format(),
        currency(item.income, currFormat).format(),
        currency(item.outcome, currFormat).format(),
        currency(item.amount_close, currFormat).format()
    ]))


    arrLines = [...arrLines,
    [{ content: "", colSpan: 7, styles: { fillColor: [220, 220, 220], textColor: [0, 0, 0] } },
    ],
    [{ content: `Totales:`,  colSpan:4, styles: { fillColor: [220, 220, 220], textColor: [0, 0, 0] } },
    { content: totalEnt,  styles: { fillColor: [220, 220, 220], textColor: [0, 0, 0] } },
    { content: totalSal,  styles: { fillColor: [220, 220, 220], textColor: [0, 0, 0] } },
    { content: "", styles: { fillColor: [220, 220, 220], textColor: [0, 0, 0] } },
    ]
    ]

    var props = {
        outputType: 'blob',
        returnJsPDFDocObject: true,
        fileName: `CashByDate-${new Date()}`,
        orientationLandscape: false,
        logo: {
            src: logo,
            width: 30.33, //aspect ratio = width/height
            height: 26.66,
            margin: {
                top: 0, //negative or positive num, from the current position
                left: 0 //negative or positive num, from the current position
            }
        },
        business: {
            name: configData.company_name,
            address: `${configData.company_address1} - ${configData.company_address2}`,
            phone: configData.company_phone,
            email: configData.company_email,
            email_1: configData.company_email1,
            website: configData.company_web_url,
            date: myDate
        },
        invoice: {
            label: `Reporte de caja por fecha`,
            label2: `Desde: ${dateFrom} - Hasta: ${dateTo}`,
            label3: "",
            headerBorder: true,
            tableBodyBorder: true,
            header: ["#", "Fecha", "Desc.", "M. Apert.", "Entradas", "Salidas", "M. Cierre"],
            table: arrLines,
            invTotalLabel: "",
            invTotal: 0,
            invCurrency: "",
            row1: {
                // col1: `Monto Apertura`,
                // col2: cash.amount_open.toFixed(2),
                // col3: '$',
                // style: {
                //     fontSize: 10 //optional, default 12
                // }
            },
            row2: {
                // col1: `Total Salidas`,
                // col2: totalSal.toFixed(2),
                // col3: '$',
                // style: {
                //     fontSize: 10 //optional, default 12
                // }
            },
            row3: {
                // col1: 'Total Entradas:',
                // col2: totalEnt.toFixed(2),
                // col3: '$',
                // style: {
                //     fontSize: 10 //optional, default 12
                // }
            },
            invDescLabel: "",
            invDesc: "",
        },
        footer: {
            text: "",
        },
        pageEnable: true,
        pageLabel: "Page ",
    };
    const pdfCreated = jsPDFCashByDateTemplate(props); //returns number of pages created
    var blob = pdfCreated.blob;

    var pdfObject = pdfCreated.jsPDFDocObject;

    window.open(URL.createObjectURL(pdfObject.output("blob")))

    // pdfCreated.jsPDFDocObject.output("blob"); //or .output('<outputTypeHere>');

};

export default generateCashByDatePrintPDF;